/*
* @Author: liang yuhong
* @Date:   2018-04-25 16:38:22
* @Last Modified by:   Ding Jianlong
* @Last Modified time: 2018-05-14 11:52:28
*/
import Vue from 'vue'
import Crypto from 'crypto'
Vue.use(Crypto)
var decryption = {}
var key = '584f6ks74f5d142l'
/**
 * 加密方法
 * @param key 加密key
 * @param iv       向量
 * @param data     需要加密的数据
 * @returns string
 */
decryption.encrypt = function (iv, data) {
  var cipher = Crypto.createCipheriv('aes-128-cbc', key, iv)
  var crypted = cipher.update(data, 'utf8', 'binary')
  crypted += cipher.final('binary')
  crypted = Buffer.alloc(crypted, 'binary').toString('base64')
  return crypted
}
/**
 * 解密方法
 * @param key      解密的key
 * @param iv       向量
 * @param crypted  密文
 * @returns string
 */
decryption.decrypt = function (iv, crypted) {
  /* crypted = new Buffer(crypted, 'base64').toString('binary')
  var decipher = Crypto.createDecipheriv('aes-128-cbc', key, iv)
  var decoded = decipher.update(crypted, 'binary', 'utf8')
  decoded += decipher.final('utf8')
  return decoded */
  crypted = Buffer.from(crypted, 'base64').toString('binary')
  var decipher = Crypto.createDecipheriv('aes-128-cbc', key, iv)
  var decoded = decipher.update(crypted, 'binary', 'utf8')
  decoded += decipher.final('utf8')
  return decoded
}
decryption.iv = function (n) {
  let rnd = ''
  for (let i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10)
  }
  return rnd
}
decryption.install = (Vue, options) => {
  Vue.prototype.$decryption = decryption
  Vue.decryption = decryption
}
export default decryption



// WEBPACK FOOTER //
// ./src/plugin/decryption.js